import { Component, Inject, OnInit } from '@angular/core';
import {
  AuthService,
  CurrentOrganizationService,
  PortalTrackingService,
} from '@onep/front-portal-lib';
import { GetUserBaseInfoAndOrganizationsGQL } from '../../../generated/types';
import { ModalInput, ONEP_MODAL_INPUT } from '@onep/ng-uikit-lib/ui/modal';
import AddressUtil from '../../utils/address-util';
import { TranslocoService } from '@ngneat/transloco';
import { GladyTrackingLogLabelizedEvent } from '@onep/front-common-lib/tracking';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.scss'],
})
export class SelectCompanyComponent implements OnInit {
  data: any;
  activeOrgId: string;
  readonly gridBgUrl = '/common/assets/grid-bg.svg';
  readonly gladyNoBorderUrl = '/common/assets/no-background-icon.glady.svg';

  constructor(
    private authService: AuthService,
    private getUserBaseInfoAndOrgGQL: GetUserBaseInfoAndOrganizationsGQL,
    @Inject(ONEP_MODAL_INPUT) private modalInput: ModalInput,
    private currentOrganizationService: CurrentOrganizationService,
    private trackingService: PortalTrackingService,
    private transloco: TranslocoService,
    private securityService: OidcSecurityService
  ) {
    this.activeOrgId = this.modalInput.input.currentOrganizationId;
  }

  ngOnInit(): void {
    this.getUserBaseInfoAndOrgGQL.fetch().subscribe((result) => {
      const dataResult = result.data;
      this.data = {
        login: dataResult?.authenticatedUser.login,
        managerOf: dataResult?.authenticatedUser?.managerOf
          ?.slice()
          ?.sort((a, b) => {
            const textA = a?.name.toLowerCase();
            const textB = b?.name.toLowerCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          })
          .map((value) => {
            return {
              id: value.id,
              name: value.name,
              siret: value.siret,
              billingAddress: value.billingAddress,
            };
          }),
      };
    });
  }

  formatFirstAddressBloc(addressToFormat: any | null | undefined): string {
    return AddressUtil.formatFirstAddressBloc(addressToFormat);
  }

  formatSecondAddressBloc(addressToFormat: any | null | undefined): string {
    return AddressUtil.formatSecondAddressBloc(addressToFormat, this.transloco);
  }

  onLogoutClick(): void {
    this.authService.logout();
  }

  switchCompany(organizationId: string, rank: number): void {
    window.localStorage.setItem(
      'secret',
      Md5.hashStr(this.securityService.getRefreshToken())
    );
    this.trackingService.sendEvent(
      new GladyTrackingLogLabelizedEvent(
        'organizationSelection',
        rank.toString()
      )
    );
    this.currentOrganizationService.switchOrganization(organizationId);
  }
}
